import { VFC } from 'react';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { FormattedMessage } from 'react-intl';
import { useReplaceMeterStepsStore } from '../../useStepsStore';
import { Button } from '../../../../components/Button/Button';
import { REVIEW_STEP_FORM_ID } from './constants';
import { ReviewStepFooter as messages } from './messages';

export const ReviewStepFooter: VFC = () => {
  const { isSendingData } = useReplaceMeterStore();

  const { setPreviousStep } = useReplaceMeterStepsStore();

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Button key="submit" block form={REVIEW_STEP_FORM_ID} htmlType="submit" loading={isSendingData} type="primary">
        {isSendingData ? <FormattedMessage {...messages.sending} /> : <FormattedMessage {...messages.confirm} />}
      </Button>
    </>
  );
};
